const overLimit = (ticket, change, limit) =>
  change === 1 && ticket.quantity === limit

const hitMinimums = (ticket, minimums) => {
  const memberGroup = ticket.member ? minimums.member : minimums.nonMember
  return ticket.quantity <= memberGroup[ticket.ageGroup]
}

const isOnlyAdultInCart = (step, ticket, delta) =>
  !step && ticket.ageGroup === 'adult' && delta === -1 && ticket.quantity === 1

export const isMemberTicket = ticket =>
  ticket.label.toLowerCase().includes('members')

export const updateTickets = (event, ticket) => {
  let ticketInCart = false
  const newTickets = event.tickets.map(existingTicket => {
    if (existingTicket.priceTypeId === ticket.priceTypeId) {
      ticketInCart = true
      return ticket
    }
    return existingTicket
  })
  return [ticketInCart, newTickets]
}

export const goingNegative = (ticket, change) =>
  change === -1 && ticket.quantity === 0

export const overMembershipMax = (ticket, change, limit) =>
  isMemberTicket(ticket) && overLimit(ticket, change, limit)

export const stopChange = (
  delta,
  ticket,
  step,
  minimums,
  hitMaximumsByAge,
  stopDecrement,
  stopIncrement
) => {
  let noIncrement, noDecrement
  let hitMaximums =
    hitMaximumsByAge[ticket.member ? 'member' : 'nonMember'][
      ticket.pricingGroup == 'chicago' || ticket.pricingGroup == 'illinois'
        ? 'resident'
        : 'nonResident'
    ][ticket.ageGroup]

  let constituencyMax = hitMaximumsByAge?.nonMember?.nonResident?.constituency
  if (!hitMaximums && Array.isArray(constituencyMax)) {
    let constituencyIdsHitMax = constituencyMax.map(p => p.priceTypeId)
    hitMaximums = constituencyIdsHitMax.includes(ticket.priceTypeId)
  }
  noIncrement = hitMaximums || stopIncrement
  noDecrement =
    stopDecrement ||
    goingNegative(ticket, delta) ||
    isOnlyAdultInCart(step, ticket, delta) ||
    (minimums && hitMinimums(ticket, minimums))
  return [noIncrement, noDecrement]
}
